import React from 'react';
import PropTypes from 'prop-types';
import { dateCardFormat } from '../../utils';

const ImageCard = ({ link, title, fullDate, description, thumbnail, isNews = false }) => {
  const getMarkup = () => description;
  return (
    <li className="box-image-card box">
      <a className="box-link" href={link} target="_blank" rel="noopener noreferrer" title={title}>
        <article className="box-article">
          <div
            className="box-image-wrapper"
            style={isNews ? { backgroundImage: `url(${thumbnail})` } : null}
          >
            <img alt="" className="box-image" src={thumbnail} />
          </div>
          <div className="box-inner-wrapper">
            <time className="box-date">{dateCardFormat(fullDate)}</time>
            <h1 className="box-title">{title}</h1>
            <p className="box-description" dangerouslySetInnerHTML={{ __html: getMarkup() }} />
            <span className="box-link">
              Read more <i className="icon icon-budicon-461" aria-hidden="true" />
            </span>
          </div>
        </article>
      </a>
    </li>
  );
};

ImageCard.propTypes = {
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  fullDate: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  thumbnail: PropTypes.string.isRequired,
  isNews: PropTypes.bool
};

export default ImageCard;



// WEBPACK FOOTER //
// ./src/pages/press/components/ImageCard/ImageCard.js